import { Box, Grid, Typography } from '@mui/material';
import React from 'react';

export default function CompareProductSavings({ product }) {
  const { estimatedEnergySavings5Years, estimatedOperatingCost5Years } = product;

  return (
    <Box maxWidth={310}>
      {(estimatedEnergySavings5Years || estimatedOperatingCost5Years) && (
        <Typography variant="h4" component="h3" fontWeight="bold" mb={2.5}>
          Estimated Costs &amp; Savings
        </Typography>
      )}

      <Grid container spacing={2} mb={6}>
        {estimatedOperatingCost5Years && (
          <Grid item xs={12}>
            <Box
              sx={{ backgroundColor: 'gray.100' }}
              py={2}
              px={3}
              height="100%"
              display="flex"
              flexDirection="column"
            >
              <Typography mb={1.125} fontWeight="medium">
                Estimated Operating Costs Over 5 years
              </Typography>
              <Typography variant="h2" component="span">
                {estimatedOperatingCost5Years}
              </Typography>
              <Typography mt={1.125} variant="body3">
                * energy cost to run
              </Typography>
            </Box>
          </Grid>
        )}

        {estimatedEnergySavings5Years && (
          <Grid item xs={12}>
            <Box
              sx={{ backgroundColor: 'green.100' }}
              py={2}
              px={3}
              height="100%"
              display="flex"
              flexDirection="column"
            >
              <Typography mb={1.125} fontWeight="medium">
                Estimated Energy Cost Savings Over 5 Years
              </Typography>
              <Typography variant="h2" component="span" flexGrow={1}>
                {estimatedEnergySavings5Years}
              </Typography>
              <Typography mt={1.125} variant="body3">
                * compared to avg model of same size + class
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
